<template>
  <div id="app">
    <div v-if="$route.path=='/login'||$route.path=='/scanout'||$route.path=='/loading||'  ">
      <router-view class="main"></router-view>

    </div>
    <div
      v-else
      style="   min-width:800px;"
    >
      <yzfooter ></yzfooter>
      <router-view
        class="main"
        style="   min-height:calc(100vh - 80px);"
      ></router-view>
      <yzheader></yzheader>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
html,
body,
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue